const setCopyPlace = {
  true: 'Galho',
  false: 'Folha',
  text: 'selecionado(a)',
  text1: 'adicionado(a) a área de transferência'
};

export default setCopyPlace;
